import api from "./axiosInstance";

/**
 * Settings API Service
 * Handles all settings related API calls
 */

export const settingsApi = {
  /**
   * Get settings
   * GET /api/v1/settings/getSettings
   */
  getSettings: () => {
    return api.get("settings/getSettings");
  },

  /**
   * Update settings
   * PUT /api/v1/settings/update
   */
  updateSettings: (data) => {
    return api.put("settings/update", data);
  }
};

export default settingsApi;
